/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiSecurityScheme } from '../../asyncapi/models/AaiSecurityScheme';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { ModelUtils } from '../util/ModelUtils';
import { Document } from '../../core/models/Document';
import { DeleteSecuritySchemeCommand } from './DeleteSecuritySchemeCommand';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete a security scheme from an aaidocument.
 * @author c.desc2@gmail.com
 * @extends DeleteSecuritySchemeCommand
 * @class
 */
export class DeleteSecuritySchemeCommand_Aai20 extends DeleteSecuritySchemeCommand {
    public constructor(schemeName? : any) {
        if(((typeof schemeName === 'string') || schemeName === null)) {
            let __args = arguments;
            super(schemeName);
        } else if(schemeName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see DeleteSecuritySchemeCommand#doDeleteScheme(Document)
     * @param {Document} document
     * @return {*}
     */
    doDeleteScheme(document : Document) : any {
        let aai20Document : Aai20Document = <Aai20Document>document;
        if(ModelUtils.isDefined(aai20Document.components)) {
            return Library.writeNode(aai20Document.components.removeSecurityScheme(this._schemeName));
        } else {
            return null;
        }
    }

    /**
     * @see DeleteSecuritySchemeCommand#doRestoreScheme(Document, Object)
     * @param {Document} document
     * @param {*} oldScheme
     */
    doRestoreScheme(document : Document, oldScheme : any) {
        let aai20Document : Aai20Document = <Aai20Document>document;
        if(ModelUtils.isDefined(aai20Document.components)) {
            let scheme : AaiSecurityScheme = new Aai20NodeFactory().createSecurityScheme(aai20Document.components, this._schemeName);
            Library.readNode(oldScheme, scheme);
            aai20Document.components.addSecurityScheme(this._schemeName, scheme);
        }
    }
}
DeleteSecuritySchemeCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteSecuritySchemeCommand_Aai20";
DeleteSecuritySchemeCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




